<template>
<u-animate-container>
  <div class="home">
	<div class="container-fluid" :class="(isIE) ? 'no_animate' : ''">
		<b-row class="min-vh-100 position-relative">
			<b-col cols="12" class="top-container min-vh-100">
				
			</b-col>
			<div class="container"><b-row>
				<b-col md="8" lg="6" class="position-relative">	
					<div class="position-absolute text-top">
						<h2 class="section-title">{{configs['home_real_estate_title']}}</h2>
						<p>{{configs['home_real_estate_txt']}}</p>
					</div>
				</b-col></b-row>
			</div>
			<b-col cols="12" class="position-absolute text-center w-100 down-btn-wrapper">
				<img class="d-block mx-auto down-btn cursor-pointer" v-on:click="scroll_down" src="../assets/images/003_SetasHomepage.png">
			</b-col>
		</b-row>
	</div>
	<!-- <u-animate
      name="fadeInUp"
      delay="0s"
      duration="1s"
      :iteration="1"
      :offset="550"
      animateClass="animated"
      :begin="false" 
    > -->
	<div class="container main_container mb-5 pb-5" ref="main_container">
<!--	<b-row>
			<b-col cols="12" class="text-center pt-5 mt-5">
				<u-animate v-if="isIE"
			      	name="fadeInUp"
				  	:offset="0"
			      	duration="0.3s"
				  	delay="1s"
				  	:begin="true" 
			      	:iteration="1"
			    >
		    		<h2 class="section-title">{{configs['home_welcome_title']}}</h2>
					<b-col lg="8" offset-lg="2">
						<p v-html="configs['home_welcome_txt']"></p>
					</b-col>
				</u-animate>
				<u-animate v-else
				   	name="fadeInUp"
					:offset="180"
					duration="1s"
					:iteration="1"	
                 >
		    		<h2 class="section-title">{{configs['home_welcome_title']}}</h2>
					<b-col lg="8" offset-lg="2">
						<p v-html="configs['home_welcome_txt']"></p>
					</b-col>
				</u-animate>
			</b-col>
		</b-row> -->
		<b-row class="d-md-flex d-none mt-5">
			<b-col md="5">
				<router-link tag="div" class="bg-scale cursor-pointer position-relative" :to="{name: 'portfolio', params: {lang: $route.params.lang, type: 'real-estate-investement'}}">
					<div class="bg-scale-content position-absolute">
						<h3 class="section-title line-up-white text-white d-inline-block m-0">{{configs['home_thumbs_portfolio_title']}}</h3>
						<p class="text-white">{{configs['home_thumbs_portfolio_txt']}}</p>
					</div>
					<div class="thumb position-relative portfolio_thumb bg">
					</div>
				</router-link>
			</b-col>
			<b-col md="7">
				<b-col cols="12" class="p-0">
					<router-link tag="div" class="bg-scale cursor-pointer position-relative" :to="'/' +$route.params.lang+ '/about'">
						<div class="bg-scale-content position-absolute">
							<h3 class="section-title line-up-white text-white d-inline-block m-0">{{configs['home_thumbs_about_title']}}</h3>
							<p class="text-white">{{configs['home_thumbs_about_txt']}}</p>
						</div>
						<div class="thumb position-relative about_us_thumb bg">
						</div>
					</router-link>
				</b-col>
				<b-col cols="12" class="p-0 m-t-30">
					<router-link tag="div" class="bg-scale cursor-pointer position-relative" :to="'/' +$route.params.lang+ '/investors'">
						<div class="bg-scale-content position-absolute">
							<h3 class="section-title line-up-white text-white d-inline-block mb-0">{{configs['home_thumbs_investors_title1']}}</h3>
						<p class="text-white">{{configs['home_thumbs_investors_txt']}}</p>
						</div>
						<div class="thumb position-relative investors_thumb bg">
						</div>
					</router-link>
				</b-col>
			</b-col>
		</b-row>
		<b-row class="d-flex d-md-none">
			<b-col cols="12" class="p-0">
				<b-col cols="12" class="mt-4">
					<router-link tag="div" :to="{name: 'portfolio', params: {lang: $route.params.lang, type: 'real-estate-investement'}}" class="thumb position-relative portfolio_thumb mob">
						<div class="thumb_text p-3 w-100 position-absolute">
							<h3 class="section-title d-inline-block line-up-white text-white">{{configs['home_thumbs_portfolio_title']}}</h3>
							<p class="text-white">{{configs['home_thumbs_portfolio_txt']}}</p>
						</div>
					</router-link>
				</b-col>
				<b-col cols="12" class="mt-4">
					<router-link tag="div" :to="'/' +$route.params.lang+ '/about'" class="thumb position-relative about_us_thumb mob">
						<div class="thumb_text pl-lg-4 p-3 w-100 position-absolute">
							<h3 class="section-title d-inline-block line-up-white text-white">{{configs['home_thumbs_about_title']}}</h3>
							<p class="text-white">{{configs['home_thumbs_about_txt']}}</p>
						</div>
					</router-link>
				</b-col>
				<b-col cols="12" class="mt-4">
					<router-link tag="div" :to="'/' +$route.params.lang+ '/investors'" class="thumb position-relative investors_thumb mob">
						<div class="thumb_text p-3 w-100 position-absolute">
							<h3 class="section-title d-inline-block line-up-white text-white mb-0">{{configs['home_thumbs_investors_title1']}}</h3>
							<p class="text-white">{{configs['home_thumbs_investors_txt']}}</p>
						</div>
					</router-link>
				</b-col>
			</b-col>
		</b-row>
	</div>
<!--	<div class="container-fluid main_container space-to-footer bg-grey">
		<div class="container mt-5 p-0">
			<b-row>
				<b-col cols="12" class="text-center">
					<h2 class="section-title">{{configs['home_portfolio_title']}}</h2>
					<b-col lg="8" offset-lg="2">
						<p>{{configs['home_ft_portfolio_txt']}}</p>
					</b-col>
				</b-col>
			</b-row>
			<b-row class="mt-5 w-md-75 mx-auto">
				<b-col v-if="cat.show_on_home" md="6" sm="8" offset-sm="2" offset-md="0" class="port_container mt-lg-0 mt-3" v-for="(cat, idx) in configs['projects_categories']" :key="idx">
					<router-link tag="div" class="bg-scale port cursor-pointer position-relative" :to="{name: 'portfolio', params: {lang: $route.params.lang, type: cat.slug}}">
						<div class="bg-scale-content position-absolute">
							<h3 class="section-title line-up-white text-white d-inline-block" v-html="cat.name"></h3>
						</div>
						<div class="bg h-100 w-100" :style="'background-image: url(' +cat.thumb+ ');'"></div>
					</router-link>
				</b-col>
			</b-row>
		</div>
	</div> -->
	<Footer></Footer>
  </div>
  </u-animate-container>
</template>

<script>
export default {
	name: 'home',
	methods: {
		scroll_down: function() {
			// window.scrollTo(0, 1000);
			if(window.scrollY < this.main_container_offsettop && window.scrollY <= document.body.scrollHeight) {
				window.scroll(0, window.scrollY+6);
				const that = this;
				setTimeout(function() {
					that.scroll_down();
				}, 1);
			}
		}
	},
	computed: {
		main_container_offsettop: function() {
			return this.$refs.main_container.offsetTop;
		}
	},
	created() {
	}
}
</script>
<style scoped>
.top-container {
	background-image: url('../assets/images/002_BackgroundHomepage.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
}
.text-top {
	top: -260px;
}
.text-top p {
	font-size: 18px;
}
.down-btn-wrapper {
	bottom: 30px;
	left: 0;
}
img {
	display: block;
}

.thumb h1:nth-child(1) {
	display: inline-block;
}
.thumb h1:nth-child(2) {
	
}
.thumb_text {
	bottom: 0;
	left: 0;
}

.main_container {
	padding-top: 60px;
}


/*.port_container:nth-child(1) > div {
	background-image: url('../assets/images/RealEstate_FeaturedPortfolio.png');
}
.port_container:nth-child(2) > div {
	background-image: url('../assets/images/RealEstatePromotion_FeaturedPortfolio.png');
}
.port_container:nth-child(3) > div {
	background-image: url('../assets/images/DevelopedProjects_FeaturedPortfolio.png');
}*/
.thumb {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
}
.portfolio_thumb {
	height: 430px;
	background-image: url('../assets/images/Portfolio.jpg');
}
.about_us_thumb {
	height: 200px;
	background-image: url('../assets/images/About-Us.jpg');
}
.investors_thumb {
	height: 200px;
	background-image: url('../assets/images/Investors.jpg');
}
.portfolio_thumb.mob, .about_us_thumb.mob, .investors_thumb.mob {
	height: 200px;
}
.down-btn {
  font-size: 35px;
  animation: MoveUpDown 1s linear infinite;
  position: relative;
  left: 0;
  bottom: 0;
}

.thumb h1 {
	bottom: 50px;
}



.bg-scale.port {
	height: 380px;
}
.bg-scale .bg-scale-content {
	bottom: 0;
}

@keyframes MoveUpDown {
  0%, 100% {
    bottom: 0;
  }
  50% {
    bottom: 5px;
  }
}

@media screen and (max-width:991.98px) {
	.bg-scale.port {
		height: 300px;
	}
}
@media screen and (max-width:767.98px) {
	.bg-scale.port {
		height: 260px;
	}
	.text-top {
		top: -270px;
	}
	.down-btn-wrapper {
		bottom: 50px;
	}
	.port_container {
	
	}
}

</style>